import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from 'vue'
import { MinimumTimeslot } from '@/models/public/service.model'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetSlot',
  props: {
  widgetSlot: {
    type: Object as PropType<MinimumTimeslot | undefined>,
    default: undefined,
  },
  selectedSlots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
},
  emits: ['onClick'],
  setup(__props, { emit: emits }) {

const props = __props





const isSelected = computed<boolean>(() =>
  props.selectedSlots.some((slot) => _.isEqual(slot, props.widgetSlot)),
)

const handleClick = () => {
  if (props.widgetSlot) {
    emits('onClick', props.widgetSlot)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["widget-calendar-slot", [
      !__props.widgetSlot && 'widget-calendar-slot--none',
      _unref(isSelected) && 'widget-calendar-slot--selected',
    ]]),
    onClick: handleClick
  }, null, 2))
}
}

})